
import { Injectable } from '@angular/core';

import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class DateParserFormatter extends NgbDateParserFormatter {

    parse(value: string): NgbDateStruct | null {
        let result: NgbDateStruct | null = null;
        if (value) {
            const date = value.split('/');
            result = {
                day: Number.parseInt(date[0]),
                month: Number.parseInt(date[1]),
                year: Number.parseInt(date[2])
            };
        }
        return result;
    }

    format(date: NgbDateStruct): string {
        let result: string | null = '';
        if (date) {
            result = `${date.day}/${date.month}/${date.year}`;
        }
        return result;
    }

}
